// import global from '@/util/mixin/global'
import { mapState } from 'vuex'

/*
 * 单位级联选择器
 */
const flatten = (d , pid = 0 , ret = {}) => {
  for(let i of d){
    let d = { value : i.value , label:i.label }
    if(pid) d.parentId = pid
    ret[d.value] = d

    if(i.children){
      flatten(i.children , i.value , ret)
    }
  }
  return ret
}

const insertMap = { 10:'支队', 20:'大队' , 30 : '中队' , 40:'小队'}
const fix = (a , parentId) => {
  let level = a[0].level , value = level+'@'+parentId

  if(insertMap[level]){
    a.unshift({value , level, label:'全部'+insertMap[level],children:[]})
  }
  return a
}
const fixCollection = (d , parentId = 0) => {

  d.forEach(i => {
    i.value = String(i.value)
    i.label = i.label
    if(i.children && i.children.length > 0) {
      i.children = fixCollection(i.children , i.value)
    }else{
      i.children = []
    }
  })

  fix(d , parentId)

  return d
}

var dataCache = null
var lastSubjectId

export default {
  name:'CompanyCascader',
  // mixins:[global],
  computed:{
    ...mapState({
      isCompany: state => state.auth.isCompany,
      isAdmin: state => state.auth.isAdmin,
      subjectId:state => state.auth.subjectId,
    }),
  },
  props:{
    value:null,
    force:{
      type: Boolean,
      default: false
    },
    byname:{
      type: Boolean,
      default:false
    },
    disabled:{
      type: Boolean,
      default:false
    },
    dept:{
      type: Boolean,
      default:false
    },
    placeholder:{
      type: String,
      default:'请选择'
    },
    //在子集添加 【全部xx】条目
    collection:{
      type: Boolean,
      default:false
    },
    //禁用缓存
    nocache:{
      type:Boolean,
      default:false
    },
    //自动选中第一项（如果可用）
    autoSelect:{
      type:Boolean,
      default:false
    },
    levels:{
      default(){
        return [10,20,30]
      }
    }
  },
  data(){
    return {
      raw:[],
      data:[],
      currentCompany:null,
      currentCompanyIds:[]
    }
  },
  methods:{
    handleChange(_, selectedData){
      this.emit(selectedData[selectedData.length-1])
    },
    emit(data = {}, selectedEvent){
      
      this.currentCompany = data.value
      let publicValue = this.byname ? data.label : data.value
      let publicData = data

      if(this.collection && /@/.test(publicValue) ){
        let pairs = publicValue.split('@').map(Number)
        let value = parseInt(pairs[1])
        let children = this.raw.filter(i => i.parentId == value).map(i => parseInt(i.value))
        publicData = {...publicData , value:value , collection:true , children}
        // value : level@companyId
      }else{
        //department
        if( publicValue < 0 ){
          publicData.departmentId = 0 - publicValue
          publicData.companyId = publicData.parentId
        }else{
          publicData.companyId = publicData.value
        }

      }

      
      if( selectedEvent ){
        publicData.autoSelect = true
      }
      this.$emit('input' , publicValue)
      this.$emit('change' , publicValue)
      this.$emit('change-data' , publicData)
    },
    comanyFormatDisplay(labels , selectedData){
      const l = labels.length
      const data = selectedData[l-1] || false;

      if( data ){
        if (/@/.test(data.value)) {
          if(l > 1){
            return selectedData[l-2].label + selectedData[l-1].label
          }
          else return data.label;
        }else{
          return data.label; 
        }
      }
    },
    update(insVal){
      //console.log('value',insVal)
      if( insVal ){
        if( this.byname ){
          let hit = this.raw.find(i => i.label == insVal )
          if( hit ) insVal = hit.value
          else {
            this.currentCompanyIds = []
          }
        }
        let hash = flatten(this.data)
        let r = [] , next = insVal
        while(next){
          let d = hash[next]
          if(d){
            r.unshift( d.value )
            if(d.parentId){
              next = d.parentId
            }else{
              break
            }
          }else{
            break
          }
        }

        insVal = r
      }else{
        insVal = []
      }
      this.currentCompanyIds = insVal
    },

    initData(data){
      let d = data.map(i => ({
        value:i.id,
        label:i.companyName,
        level:i.lever,
        parentId: i.parentId
      }))

      d.forEach(i => {
        i.expand = false
      })

      //允许展示部门
      if( this.dept ){
        for(let c of data){
          if( c.departments ){
            d = d.concat(c.departments.map(i => ({
              value:0-i.id,
              label:i.name,
              level:c.lever + 10,
              parentId: i.parentCompanyId
            })))
          }
        }
      }
      
      // 过滤层级
      let filterLevel = this.levels || []
      if(filterLevel.length){
        //console.log('levels',filterLevel)
        d = d.filter(i => filterLevel.includes(i.level) )
      }

      this.raw = d

      d = this.$utils.tree(d, 'value', 'parentId', 'children',0,true)

      //补充统计
      if(this.collection){
        d = fixCollection(d)
      }
      this.data = d

      let defaultValue = this.value
      if( !defaultValue && this.autoSelect ){
        defaultValue = d[0].value
        this.update(defaultValue)
        this.emit(d[0] , true)
      }else{
        this.update(defaultValue)
      }

      this.$watch('value' , function(nv){
        if( this.data && this.data.length ){
          this.update(nv)
        }
      })

    }
  },
  created(){
    let reqireUpdate = this.subjectId != lastSubjectId
    lastSubjectId = this.subjectId
    if(this.nocache || !dataCache || reqireUpdate){
      this.$request.common_company().then(resp => {
        if (!resp.code) {
          dataCache = resp.data || []
          this.initData(dataCache)
        }
      })
    }else{
      this.initData(dataCache)
    }

  },
  render(){
    let changeOnSelect = !this.force
    return <Cascader trigger="click" change-on-select={changeOnSelect} value={this.currentCompanyIds} data={this.data} on-on-change={this.handleChange} placeholder={this.placeholder} render-format={this.comanyFormatDisplay} disabled={this.disabled} />
  }
}